import React, { useState } from "react";
import QueueStatusBadge from "@/components/Queue/QueueStatusBadge";
import QueueManagementModal from "@/components/Queue/QueueManagementModal";
import { useQueueNotifications } from "@/modules/ticket/ticketQueue/useQueueNotifications";

/**
 * Integration component that combines queue badge, modal, and notifications
 *
 * Usage:
 * Add this component to your App/Navigation to enable queue UX:
 *
 * ```tsx
 * import QueueIntegration from '@/components/Queue/QueueIntegration';
 *
 * function MainNavigation() {
 *   return (
 *     <BottomNavigation>
 *       <QueueIntegration />
 *       // ... other nav items
 *     </BottomNavigation>
 *   );
 * }
 * ```
 */
const QueueIntegration: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);

  // Queue manager is initialized at App level to avoid duplicate triggers

  // Enable toast notifications
  useQueueNotifications();

  return (
    <>
      <QueueStatusBadge onClick={() => setModalOpen(true)} />
      <QueueManagementModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default QueueIntegration;
